require('./card.component.scss');

class CardController {
  constructor(
    $scope,
    CurrentFilterService,
    PermissionService,
    LayoutService,
    RouterService,
  ) {
    this.$scope = $scope;
    this.CurrentFilterService = CurrentFilterService;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.keysFilter = ['agent_account.guid', 'agent_account.id', 'agent_agent.guid', 'agent_agent.id'];
  }
}

export const CardComponent = {
  template: require('./card.component.html'),
  bindings: {
    filter: '<',
    card  : '<',
  },
  controller: CardController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/card.component.js